export default "__VITE_ASSET__Bd$ysVH2__"